// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"d49f5cb0","404":"d370f174","632":"55b60032","777":"ae018b3d"}[chunkId] + ".chunk.js";
};